/* 文章页交互，两组：由正文标题生成目录、由滚动位置推进目录顶部的进度条。
   只在文章页加载一次（layout/theme.liquid 按 request.page_type == 'article' 判断）。

   scroll / resize 挂在与 window 上，编辑器里每次重渲染 section 都会多留一份，
   而且回调闭包钉住旧 DOM —— 光靠 WeakMap 回收不掉，必须在 shopify:section:unload
   时显式摘掉；IntersectionObserver 同理，要 disconnect。

   目录链接的点击统一在 document 上委托，不加在各自链接上：目录条目是这里动态
   建出来的，委托后重渲染不需要重新绑定。 */

(function () {
  const articleStates = new WeakMap();

  const buildTableOfContents = (root, state) => {
    const content = root.querySelector('[data-article-content]');
    const toc = root.querySelector('[data-article-toc]');
    const list = root.querySelector('[data-article-toc-list]');
    if (!content || !toc || !list) return;
    list.replaceChildren();

    const headings = [...content.querySelectorAll('h1, h2, h3')].filter((heading) => heading.textContent.trim());
    if (!headings.length) {
      root.classList.add('starole-article--without-toc');
      toc.hidden = true;
      return;
    }
    root.classList.remove('starole-article--without-toc');

    // 正文里的标题可能重名，重名时逐个加 -2、-3 后缀；也可能与页面上已有的
    // id 撞车（别的 section 用掉了），撞了同样要换。
    const usedIds = new Set();
    const links = [];
    headings.forEach((heading, index) => {
      let id = heading.id || heading.textContent.trim().toLowerCase()
        .normalize('NFKD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-|-$/g, '') || `section-${index + 1}`;
      const baseId = id;
      let suffix = 2;
      while (usedIds.has(id) || (document.getElementById(id) && document.getElementById(id) !== heading)) id = `${baseId}-${suffix++}`;
      usedIds.add(id);
      heading.id = id;

      const item = document.createElement('li');
      if (heading.tagName === 'H2') item.classList.add('is-subheading');
      if (heading.tagName === 'H3') item.classList.add('is-subheading', 'is-third-level');
      const link = document.createElement('a');
      link.href = `#${id}`;
      link.textContent = heading.textContent.trim();
      item.appendChild(link);
      list.appendChild(item);
      links.push(link);
    });
    toc.hidden = false;
    state.links = links;

    if ('IntersectionObserver' in window) {
      state.observer = new IntersectionObserver((entries) => {
        const visible = entries.filter((entry) => entry.isIntersecting).sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top)[0];
        if (!visible) return;
        links.forEach((link) => link.classList.toggle('is-active', link.hash === `#${visible.target.id}`));
      }, { rootMargin: '-110px 0px -65% 0px', threshold: 0 });
      headings.forEach((heading) => state.observer.observe(heading));
    }
  };

  const initializeProgress = (root, state) => {
    const content = root.querySelector('[data-article-content]');
    const progress = root.querySelector('[data-article-progress]');
    if (!content || !progress) return;

    const update = () => {
      const rect = content.getBoundingClientRect();
      const distance = Math.max(content.offsetHeight - window.innerHeight * 0.45, 1);
      const percentage = Math.min(Math.max((-rect.top + window.innerHeight * 0.22) / distance, 0), 1);
      progress.style.transform = `scaleX(${percentage})`;
    };
    update();
    state.onScroll = update;
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
  };

  const teardownArticle = (root) => {
    const state = articleStates.get(root);
    if (!state) return;
    if (state.onScroll) {
      window.removeEventListener('scroll', state.onScroll);
      window.removeEventListener('resize', state.onScroll);
    }
    if (state.observer) state.observer.disconnect();
    articleStates.delete(root);
  };

  const initArticle = (root) => {
    if (articleStates.has(root)) return;
    const state = { links: [], observer: null, onScroll: null };
    articleStates.set(root, state);
    buildTableOfContents(root, state);
    initializeProgress(root, state);
  };

  const initAll = (scope = document) => scope.querySelectorAll('[data-starole-article]').forEach(initArticle);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document));
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));

  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-starole-article]').forEach(teardownArticle);
  });

  document.addEventListener('click', (event) => {
    const link = event.target.closest?.('[data-article-toc-list] a');
    if (!link) return;
    const root = link.closest('[data-starole-article]');
    const state = root && articleStates.get(root);
    if (!state) return;
    state.links.forEach((entry) => entry.classList.toggle('is-active', entry === link));
  });
})();
